export default "__VITE_ASSET__C4Ex7SHI__"